@for (group of groups; track group) {
    <button class="link" (click)="setActive(group)" [ngClass]="{'active':isActive(group)}"
    >
        @if (group.isInvalid) {
            <div class="link-media">
                <fui-icon class="link-media-object" [height]="12" [icon]="'error'" [width]="12"></fui-icon>
            </div>
        }
        <div class="link-label">
            <div class="link-label-title">
                {{ group.title | translate }}
            </div>
        </div>
    </button>
}
